"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLIDER_PERCENTAGE = exports.THUMB_RIGHT_SLIDER_CLASS = exports.THUMB_LEFT_SLIDER_CLASS = exports.GROUP_SUFIX_RIGHT = exports.GROUP_SUFIX_LEFT = exports.GROUP_SLIDER_DOUBLE_SUFIX = exports.SLIDER_N100 = exports.TAG_NAME_SLIDER_EXPECTED = exports.THUMB_SLIDER_CLASS = exports.GROUP_SLIDER_SUFIX = exports.SLIDER_N10 = exports.SLIDER_N24 = exports.SLIDER_N12 = exports.SLIDER_N14 = exports.SLIDER_N90 = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.SLIDER_N90 = 90;
exports.SLIDER_N14 = 14;
exports.SLIDER_N12 = 12;
exports.SLIDER_N24 = 24;
exports.SLIDER_N10 = 10;
exports.GROUP_SLIDER_SUFIX = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-slider");
exports.THUMB_SLIDER_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-slider-thumb");
exports.TAG_NAME_SLIDER_EXPECTED = "INPUT";
exports.SLIDER_N100 = 100;
exports.GROUP_SLIDER_DOUBLE_SUFIX = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-slider-double-container");
exports.GROUP_SUFIX_LEFT = "input-left";
exports.GROUP_SUFIX_RIGHT = "input-right";
exports.THUMB_LEFT_SLIDER_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-slider-thumb-left");
exports.THUMB_RIGHT_SLIDER_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-slider-thumb-right");
exports.SLIDER_PERCENTAGE = 100;
